import React from 'react';
import EditMealContent from './content';
import { MealProvider } from 'contexts/meal.context';

const EditMealLayout = () => {
  return (
    <MealProvider>
      <EditMealContent />
    </MealProvider>
  );
};

export default EditMealLayout;
